import React from 'react';
import './DirectLinkIcon.scss';

const DirectLinkIcon = () => {
    return (
        <svg
            className="component-Icons-DirectLinkIcon"
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g
                id="Icons/link-direct"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="rectangle" fill="none">
                    <rect
                        id="Rectangle-Copy-6"
                        x="0"
                        y="0"
                        width="30"
                        height="30"
                    />
                </g>
                <g
                    id="icon-colored-section"
                    transform="translate(6.000000, 6.000000)"
                >
                    <path
                        d="M9.59466452,9.53032469 C9.30177428,9.23742849 9.30177911,8.76255476 9.59467531,8.46966452 C9.88757151,8.17677428 10.3624452,8.17677911 10.6553355,8.46967531 L12.9053355,10.7197211 C13.1982257,11.0126173 13.1982209,11.487491 12.9053247,11.7803813 L10.6553247,14.0303355 C10.3624285,14.3232257 9.88755476,14.3232209 9.59466452,14.0303247 C9.30177428,13.7374285 9.30177911,13.2625548 9.59467531,12.9696645 L10.5596451,12 L7.5,12 L7.5,15 L15,15 L15,7.5 L7.5,7.5 L7.5,10.5 L10.5596451,10.5 L9.59466452,9.53032469 Z M15.0011854,6 C15.8289579,6 16.5,6.67279509 16.5,7.49881458 L16.5,15.0011854 C16.5,15.8289579 15.8272049,16.5 15.0011854,16.5 L7.49881458,16.5 C6.67104214,16.5 6,15.8272049 6,15.0011854 L6,12 L2.99881458,12 C2.17104214,12 1.5,11.3272049 1.5,10.5011854 L1.5,2.99881458 C1.5,2.17104214 2.17279509,1.5 2.99881458,1.5 L10.5011854,1.5 C11.3289579,1.5 12,2.17279509 12,2.99881458 L12,6 L15.0011854,6 Z M10.5,3 L3,3 L3,10.5 L6,10.5 L6,7.49881458 C6,6.67104214 6.67279509,6 7.49881458,6 L10.5,6 L10.5,3 Z"
                        id="Combined-Shape"
                    />
                </g>
            </g>
        </svg>
    );
};

DirectLinkIcon.displayName = 'DirectLinkIcon';

export default React.memo(DirectLinkIcon);
